import React from "react";
import { Card, FormLabel, Grid, Stack, Tooltip } from "@mui/material";
import InfoIcon from '@mui/icons-material/Info';
import { Series } from "../Dashboard/Dashboard";

export type DashboardItems = {
  mitigation_rate: number;
  impact_rate: number;
  time_to_impact?: number;
  solutions: {
    approved: number;
    series: Series[];
  };
}

const SolutionDashboard = (props: { items?: DashboardItems }) => {

  return <Grid id="dashboard" container spacing={3}>

    <Grid size={{xs: 12, md: 4}}>
      <Card>
        <h3>Solutions</h3>
        <h2 className='text-light'>{typeof(props.items?.solutions?.approved) !== "undefined" ? props.items?.solutions.approved : '-'} <FormLabel><span className="text-secondary">delivered</span></FormLabel></h2>
      </Card>
    </Grid>

    <Grid size={{xs: 12, md: 4}}>
      <Card>
        <h3>Time to impact<Tooltip title="Average days from lesson capturing to resolved solution." sx={{ml: 0.5}}><InfoIcon color="secondary" fontSize="small" /></Tooltip></h3>
        <Stack direction="row" alignItems="center" gap={2}>
          <h3 className='text-light'>{props.items?.time_to_impact ? <>{props.items.time_to_impact} <FormLabel><span className="text-secondary">days</span></FormLabel></> : <FormLabel><span className="text-secondary">Not enough data</span></FormLabel>}</h3>
        </Stack>
      </Card>
    </Grid>
    
    <Grid size={{xs: 12, md: 4}}>
      <Card>
        <FormLabel>Mitigation rate<Tooltip title="Amount of lessons learned that got into a solution process." sx={{ml: 0.5}}><InfoIcon color="secondary" fontSize="small" /></Tooltip></FormLabel>
        <Stack direction="row" alignItems="center" gap={2}>
          <h3 className='text-light'>{typeof(props.items?.mitigation_rate) !== "undefined" ? props.items.mitigation_rate : '-'} <FormLabel><span className="text-secondary">%</span></FormLabel></h3>
        </Stack>
      
        <FormLabel sx={{mt: 2}}>Impact rate<Tooltip title="Amount of solutions marked as successful." sx={{ml: 0.5}}><InfoIcon color="secondary" fontSize="small" /></Tooltip></FormLabel>
        <Stack direction="row" alignItems="center" gap={2}>
          <h3 className='text-light'>{typeof(props.items?.impact_rate) !== "undefined" ? props.items.impact_rate : '-'} <FormLabel><span className="text-secondary">%</span></FormLabel></h3>
        </Stack>
      </Card>
    </Grid>

  </Grid>
};

export default SolutionDashboard;
